var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamsBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_16105",
    "data-name": "Group 16105",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18.203,
    height: 21.237,
    viewBox: "0 0 18.203 21.237",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8435",
    "data-name": "Rectangle 8435",
    width: 18.203,
    height: 21.237,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16104",
    "data-name": "Group 16104",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5876",
    "data-name": "Path 5876",
    d: "M10.618,3.034a.758.758,0,0,1-.758.758H8.343a.758.758,0,0,1,0-1.517H9.86a.758.758,0,0,1,.758.758M12.135,18.2a.758.758,0,0,0,.758-.758V11.377a.758.758,0,1,0-1.517,0v6.068a.758.758,0,0,0,.758.758M18.2,5.309V8.343a.758.758,0,0,1-.758.758h-.758v8.343a3.8,3.8,0,0,1-3.792,3.792H5.309a3.8,3.8,0,0,1-3.792-3.792V9.1H.758A.758.758,0,0,1,0,8.343V5.309a.758.758,0,0,1,.758-.758h.819A5.313,5.313,0,0,1,6.826,0h4.551a5.316,5.316,0,0,1,5.252,4.551h.815A.758.758,0,0,1,18.2,5.309ZM3.11,4.551H15.092a3.8,3.8,0,0,0-3.716-3.034H6.826A3.8,3.8,0,0,0,3.11,4.551M15.169,9.1H3.034v8.343A2.278,2.278,0,0,0,5.309,19.72h7.585a2.278,2.278,0,0,0,2.275-2.275Zm-9.1,9.1a.758.758,0,0,0,.758-.758V11.377a.758.758,0,1,0-1.517,0v6.068a.758.758,0,0,0,.758.758m3.034,0a.758.758,0,0,0,.758-.758V11.377a.758.758,0,1,0-1.517,0v6.068A.758.758,0,0,0,9.1,18.2",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamsBin);
export default __webpack_public_path__ + "static/media/teams_bin.c7b74465fa5eeb7e1a087e849d6c8315.svg";
export { ForwardRef as ReactComponent };